import React from 'react'
import EditPowerOfficials from './EditPowerOfficials';
function EditPowerOfficialsPage() {
    return ( 
        <div className='container-fluid'>
            <EditPowerOfficials />
        </div>
     );
}

export default EditPowerOfficialsPage;